module.exports = __webpack_public_path__ + "static/media/Negotiation_active_Blue.96392b80.svg";